import * as client from "_graphql-types";
import * as types from "./types";

import { filterSortPage } from "../DataProvider";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.ContactTypeEnumSortEnum>
) {
  const { pagination, sort } = params;

  const {
    contactTypeEnumList: { items: data, total },
  } = await sdk.getListContactTypeEnum(
    filterSortPage({
      sort,
      pagination,
    })
  );

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { contactTypeEnum: data } = await sdk.getOneContactTypeEnum({
    id,
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { contactTypeEnumMany: data } = await sdk.getManyContactTypeEnum({
    ids,
  });

  return {
    data,
  };
}

/*********************************************************************/
export const contactTypeEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
  ttl: types.defaultEnumTtl,
});
